<app-tasas-variables-editar [verDetalle]="true"></app-tasas-variables-editar>
